import React, { useState, useRef } from 'react';
import { Container, Row, Col, Form, Card } from 'react-bootstrap';
import '../styles/Contacto.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button, Modal } from 'react-bootstrap';
import ReCAPTCHA from 'react-google-recaptcha';
import { TailSpin } from 'react-loader-spinner';
import { MultiSelect } from "react-multi-select-component";
import Select from 'react-select';
import { motion } from 'framer-motion';


function Contacto() {
    const [privacyAccepted, setPrivacyAccepted] = useState(false);

    const [name, setName] = useState('');
    const [surname, setSurname] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [company, setCompany] = useState('');
    const [message, setMessage] = useState('');
    const [errors, setErrors] = useState({});
    const [cargo, setCargo] = useState('');
    const [selectedOrigen, setSelectedOrigen] = useState("");
    const [selectedPais, setSelectedPais] = useState('España');

    const [done, setDone] = useState(false);
    const URL_DOMAIN = process.env.REACT_APP_URL_DOMAIN;
    const customStyles = {
        control: (provided) => ({
          ...provided,
          border: '1px solid #ccc',
          backgroundColor: '#f1f1f1',
          color: '#646464',
        }),
      };

    const validateEmail = (email) => {
        const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        return regex.test(email);
    };
    const captchaRef = useRef(null);
    const options = [
        { label: "Recetas y Escandallos", value: "90" },
        { label: "Compras", value: "91" },
        { label: "Ventas", value: "92" },
        { label: "Foodcost/Analisis de datos", value: "93" },
        { label: "Almacenes/Inventarios", value: "94" },
        { label: "Trazabilidad", value: "95" },
        { label: "Producción/Planificación", value: "96" },
        { label: "Etiquetado", value: "97" },
        { label: "Buffets", value: "98" },

    ];

    const origen = [
        { label: "Linkedin", value: "116" },
        { label: "Instagram", value: "117" },
        { label: "Distribuidores", value: "118" },
        { label: "Recomendado", value: "119" },
        { label: "Talent Class", value: "120" },
        { label: "BCC", value: "121" },
        { label: "Google Ad", value: "122" },
        
    {
        value: "168",
        label: "Youtube"
    },
    {
        value: "169",
        label: "Buscadores Web"
    },
    {
        value: "170",
        label: "Ferias"
    },
    {
        value: "171",
        label: "Internet"
    },
    {
        value: "172",
        label: "Intercom"
    },
        { label: "Otros", value: "123" },

    ];


    const pais = [
        { label: "España", value: "1" },
        { label: "Andorra", value: "2" },
        
        // Latin American countries
        { label: "Argentina", value: "3" },
        { label: "Bolivia", value: "4" },
        { label: "Brasil", value: "5" },
        { label: "Chile", value: "6" },
        { label: "Colombia", value: "7" },
        { label: "Costa Rica", value: "8" },
        { label: "Cuba", value: "9" },
        { label: "Ecuador", value: "10" },
        { label: "El Salvador", value: "11" },
        { label: "Guatemala", value: "12" },
        { label: "Honduras", value: "13" },
        { label: "México", value: "14" },
        { label: "Nicaragua", value: "15" },
        { label: "Panamá", value: "16" },
        { label: "Paraguay", value: "17" },
        { label: "Perú", value: "18" },
        { label: "República Dominicana", value: "19" },
        { label: "Uruguay", value: "20" },
        { label: "Venezuela", value: "21" },
    
        // European countries (excluding Spain and Andorra)
        { label: "Albania", value: "22" },
        { label: "Alemania", value: "23" },
        { label: "Austria", value: "24" },
        { label: "Bélgica", value: "25" },
        { label: "Bielorrusia", value: "26" },
        { label: "Bosnia y Herzegovina", value: "27" },
        { label: "Bulgaria", value: "28" },
        { label: "Chipre", value: "29" },
        { label: "Ciudad del Vaticano", value: "30" },
        { label: "Croacia", value: "31" },
        { label: "Dinamarca", value: "32" },
        { label: "Eslovaquia", value: "33" },
        { label: "Eslovenia", value: "34" },
        { label: "Estonia", value: "35" },
        { label: "Finlandia", value: "36" },
        { label: "Francia", value: "37" },
        { label: "Grecia", value: "38" },
        { label: "Hungría", value: "39" },
        { label: "Irlanda", value: "40" },
        { label: "Islandia", value: "41" },
        { label: "Italia", value: "42" },
        { label: "Kosovo", value: "43" },
        { label: "Letonia", value: "44" },
        { label: "Liechtenstein", value: "45" },
        { label: "Lituania", value: "46" },
        { label: "Luxemburgo", value: "47" },
        { label: "Macedonia del Norte", value: "48" },
        { label: "Malta", value: "49" },
        { label: "Moldavia", value: "50" },
        { label: "Mónaco", value: "51" },
        { label: "Montenegro", value: "52" },
        { label: "Noruega", value: "53" },
        { label: "Países Bajos", value: "54" },
        { label: "Polonia", value: "55" },
        { label: "Portugal", value: "56" },
        { label: "Reino Unido", value: "57" },
        { label: "República Checa", value: "58" },
        { label: "Rumanía", value: "59" },
        { label: "Rusia", value: "60" },
        { label: "San Marino", value: "61" },
        { label: "Serbia", value: "62" },
        { label: "Suecia", value: "63" },
        { label: "Suiza", value: "64" },
        { label: "Ucrania", value: "65" },
    
        // Rest of the world in alphabetical order
        { label: "Afganistán", value: "66" },
        { label: "Angola", value: "67" },
        { label: "Antigua y Barbuda", value: "68" },
        { label: "Arabia Saudita", value: "69" },
        { label: "Argelia", value: "70" },
        { label: "Armenia", value: "71" },
        { label: "Australia", value: "72" },
        { label: "Azerbaiyán", value: "73" },
        { label: "Bahamas", value: "74" },
        { label: "Bangladés", value: "75" },
        { label: "Barbados", value: "76" },
        { label: "Baréin", value: "77" },
        { label: "Belice", value: "78" },
        { label: "Benín", value: "79" },
        { label: "Birmania", value: "80" },
        { label: "Botsuana", value: "81" },
        { label: "Brunéi", value: "82" },
        { label: "Burkina Faso", value: "83" },
        { label: "Burundi", value: "84" },
        { label: "Bután", value: "85" },
        { label: "Cabo Verde", value: "86" },
        { label: "Camboya", value: "87" },
        { label: "Camerún", value: "88" },
        { label: "Canadá", value: "89" },
        { label: "Catar", value: "90" },
        { label: "Chad", value: "91" },
        { label: "China", value: "92" },
        { label: "Comoras", value: "93" },
        { label: "Corea del Norte", value: "94" },
        { label: "Corea del Sur", value: "95" },
        { label: "Costa de Marfil", value: "96" },
        { label: "Dominica", value: "97" },
        { label: "Egipto", value: "98" },
        { label: "Emiratos Árabes Unidos", value: "99" },
        { label: "Eritrea", value: "100" },
        { label: "Eswatini", value: "101" },
        { label: "Etiopía", value: "102" },
        { label: "Filipinas", value: "103" },
        { label: "Fiyi", value: "104" },
        { label: "Gabón", value: "105" },
        { label: "Gambia", value: "106" },
        { label: "Georgia", value: "107" },
        { label: "Ghana", value: "108" },
        { label: "Granada", value: "109" },
        { label: "Guinea", value: "110" },
        { label: "Guinea Ecuatorial", value: "111" },
        { label: "Guinea-Bisáu", value: "112" },
        { label: "Guyana", value: "113" },
        { label: "Haití", value: "114" },
        { label: "India", value: "115" },
        { label: "Indonesia", value: "116" },
        { label: "Irak", value: "117" },
        { label: "Irán", value: "118" },
        { label: "Israel", value: "119" },
        { label: "Jamaica", value: "120" },
        { label: "Japón", value: "121" },
        { label: "Jordania", value: "122" },
        { label: "Kazajistán", value: "123" },
        { label: "Kenia", value: "124" },
        { label: "Kirguistán", value: "125" },
        { label: "Kiribati", value: "126" },
        { label: "Kuwait", value: "127" },
        { label: "Laos", value: "128" },
        { label: "Lesoto", value: "129" },
        { label: "Líbano", value: "130" },
        { label: "Liberia", value: "131" },
        { label: "Libia", value: "132" },
        { label: "Madagascar", value: "133" },
        { label: "Malasia", value: "134" },
        { label: "Malaui", value: "135" },
        { label: "Maldivas", value: "136" },
        { label: "Malí", value: "137" },
        { label: "Marruecos", value: "138" },
        { label: "Mauricio", value: "139" },
        { label: "Mauritania", value: "140" },
        { label: "Micronesia", value: "141" },
        { label: "Mongolia", value: "142" },
        { label: "Mozambique", value: "143" },
        { label: "Namibia", value: "144" },
        { label: "Nauru", value: "145" },
        { label: "Nepal", value: "146" },
        { label: "Níger", value: "147" },
        { label: "Nigeria", value: "148" },
        { label: "Nueva Zelanda", value: "149" },
        { label: "Omán", value: "150" },
        { label: "Pakistán", value: "151" },
        { label: "Palaos", value: "152" },
        { label: "Palestina", value: "153" },
        { label: "Papúa Nueva Guinea", value: "154" },
        { label: "República Centroafricana", value: "155" },
        { label: "República del Congo", value: "156" },
        { label: "República Democrática del Congo", value: "157" },
        { label: "Ruanda", value: "158" },
        { label: "Samoa", value: "159" },
        { label: "San Cristóbal y Nieves", value: "160" },
        { label: "San Vicente y las Granadinas", value: "161" },
        { label: "Santa Lucía", value: "162" },
        { label: "Santo Tomé y Príncipe", value: "163" },
        { label: "Senegal", value: "164" },
        { label: "Seychelles", value: "165" },
        { label: "Sierra Leona", value: "166" },
        { label: "Singapur", value: "167" },
        { label: "Siria", value: "168" },
        { label: "Somalia", value: "169" },
        { label: "Sri Lanka", value: "170" },
        { label: "Sudáfrica", value: "171" },
        { label: "Sudán", value: "172" },
        { label: "Sudán del Sur", value: "173" },
        { label: "Surinam", value: "174" },
        { label: "Tailandia", value: "175" },
        { label: "Taiwán", value: "176" },
        { label: "Tanzania", value: "177" },
        { label: "Tayikistán", value: "178" },
        { label: "Timor Oriental", value: "179" },
        { label: "Togo", value: "180" },
        { label: "Tonga", value: "181" },
        { label: "Trinidad y Tobago", value: "182" },
        { label: "Túnez", value: "183" },
        { label: "Turkmenistán", value: "184" },
        { label: "Turquía", value: "185" },
        { label: "Tuvalu", value: "186" },
        { label: "Uganda", value: "187" },
        { label: "Uzbekistán", value: "188" },
        { label: "Vanuatu", value: "189" },
        { label: "Vietnam", value: "190" },
        { label: "Yemen", value: "191" },
        { label: "Yibuti", value: "192" },
        { label: "Zambia", value: "193" },
        { label: "Zimbabue", value: "194" }
    ];
    const [showModal, setShowModal] = useState(false);

    const openModal = () => {
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        if (done) {
            window.location.reload();
        }
    };


    const [selected, setSelected] = useState([]);

    const options1 = [
        { label: "Restaurante", value: "17" },
        { label: "Cadena Restauración", value: "44" },
        { label: "Hotel", value: "18" },
        { label: "Hotel con Buffet", value: "19" },
        { label: "Cadena Hotelera", value: "45" },
        { label: "Dark Kitchen", value: "20" },
        { label: "Cocina Central", value: "22" },
        { label: "Eventos-Catering", value: "21" },
        { label: "Obrador Pasteleria", value: "23" },
        { label: "Industria", value: "24" },
        { label: "Tienda Online", value: "47" },
        { label: "Tienda de Comidas", value: "48" },



    ];

    const [selected1, setSelected1] = useState([]);
    const handleSubmit = async (event) => {

        event.preventDefault();

        const errors = {};

        if (!name.trim()) {
            errors.name = 'El nombre es obligatorio';
        }
        if (!surname.trim()) {
            errors.surname = 'Los apellidos son obligatorios';
        }
        if (!privacyAccepted) {
            errors.privacy = 'Debes aceptar la política de privacidad';
        }
        if (!email.trim()) {
            errors.email = 'El correo electrónico es obligatorio';
        } else if (!validateEmail(email)) {
            errors.email = 'El correo electrónico no es válido';
        }
        if (!phone.trim()) {
            errors.phone = 'El teléfono es obligatorio';
        }
        if (!company.trim()) {
            errors.company = 'La empresa es obligatoria';
        }
        if (!cargo.trim()) {
            errors.cargo = 'El cargo es obligatorio';
        }
        if (!message.trim()) {
            errors.message = 'El mensaje es obligatorio';
        }
        if (!selectedOrigen) {
            errors.origen = 'Por favor, selecciona una opción';
        }
        if (Object.keys(errors).length > 0) {
            setErrors(errors);
        } else {

            openModal();

            let token = captchaRef.current.getValue();
            captchaRef.current.reset();
            if (token) {
                let valid_token = await verifyToken(token);

                if (valid_token && valid_token.success === true) {
                    console.log("verified");

                    setName('');
                    setSurname('');
                    setEmail('');
                    setPhone('');
                    setCompany('');
                    setMessage('');
                    setErrors({});
                    setDone(true);
                } else {
                    console.log("not verified");
                    setShowModal(false);
                    setErrors({
                        submit: valid_token?.error || 'Error al verificar el formulario. Por favor, inténtalo de nuevo.'
                    });
                }
            } else {
                setShowModal(false);
                setErrors({
                    submit: 'Por favor, completa el reCAPTCHA antes de enviar el formulario.'
                });
            }

        }
    };
    const verifyToken = async (token) => {
        const negocios = selected1.map(item => item.value).join(",");
        const preferencias = selected.map(item => item.value).join(",");

        try {
            const response = await fetch(URL_DOMAIN+'/verify-token', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    name: name,
                    surname: surname,
                    email: email,
                    phone: phone,
                    message: message,
                    company: company,
                    options: negocios,
                    options1: preferencias,
                    origen: selectedOrigen,
                    pais: selectedPais,
                    token: token,
                    website: '' // Honeypot field - should always be empty
                }),
            });

            if (response.ok) {
                const data = await response.json();
                return data;
            } else {
                // Handle HTTP error responses (400, 500, etc.)
                const errorData = await response.json();
                return {
                    success: false,
                    error: errorData.error || 'Error al verificar el formulario. Por favor, inténtalo de nuevo.'
                };
            }
        } catch (error) {
            // Handle network errors
            console.error('Network error:', error);
            return {
                success: false,
                error: 'Error de conexión. Por favor, verifica tu conexión a internet e inténtalo de nuevo.'
            };
        }
    };



    return (
        <Container fluid className="bg-light py-5">
        <Row className="justify-content-center">
            <Col xs={12} md={10} lg={8}>
                <Card className="contact-form-container">
                    <Card.Body>
                        <h1 className="text-center text-ee3750 mb-4">Formulario de Contacto</h1>
                        <div className="text-center mb-5">
                            <p className="mb-3">
                                Estamos aquí para escucharte y solucionar tus problemas de gestión, así que cuando dejes la información explicando lo que necesitas, nos pondremos en contacto contigo.
                            </p>
                            <p className="font-weight-bold">
                                Lo solemos hacer bastante rápido, así que hablamos en breve 😉
                            </p>
                        </div>
                        <Form onSubmit={handleSubmit}>
                            <Row>
                                <Col xs={12} sm={4}>
                                    <Form.Group controlId="formName" className="mb-3 py-1">
                                        <h6>Nombre</h6>
                                        <Form.Control
                                            type="text"
                                            placeholder="Nombre"
                                            value={name}
                                            onChange={(event) => setName(event.target.value)}
                                            isInvalid={errors.name}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.name}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} sm={8}>
                                    <Form.Group controlId="formSurname" className="mb-3 py-1">
                                        <h6>Apellidos</h6>
                                        <Form.Control
                                            type="text"
                                            placeholder="Apellidos"
                                            value={surname}
                                            onChange={(event) => setSurname(event.target.value)}
                                            isInvalid={errors.surname}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.surname}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>

                            </Row>
                            <Row>
                                <Col xs={12} sm={4}>
                                    <Form.Group controlId="formEmail" className="mb-3 py-1">
                                        <h6>Dirección de correo electrónico</h6>
                                        <Form.Control
                                            type="email"
                                            placeholder="Dirección de correo electrónico"
                                            value={email}
                                            onChange={(event) => setEmail(event.target.value)}
                                            isInvalid={errors.email}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} sm={4}>
                                <div style={{marginTop: '5px'}}>
                                        <h6>Pais</h6>
                                        <Select value={pais.find((option) => option.value === selectedPais)}
                            onChange={(selectedOption) => setSelectedPais(selectedOption.label)}
                             options={pais} styles={customStyles} isRequired/>  
                                    </div>
                                </Col>
                                <Col xs={12} sm={4}>
                                    <Form.Group controlId="formPhone" className="mb-3 py-1">
                                        <h6>Teléfono</h6>
                                        <Form.Control
                                            type="tel"
                                            placeholder="Teléfono"
                                            value={phone}
                                            onChange={(event) => setPhone(event.target.value)}
                                            isInvalid={errors.phone}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.phone}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>

                            </Row>
                            <Row>
                                <Col xs={12} sm={7}>
                                    <Form.Group controlId="formCompany" className="mb-3 py-1">
                                        <h6>Empresa</h6>
                                        <Form.Control
                                            type="text"
                                            placeholder="Empresa"
                                            value={company}
                                            onChange={(event) => setCompany(event.target.value)}
                                            isInvalid={errors.company}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.company}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} sm={5}>
                                    <Form.Group controlId="formCargo" className="mb-3 py-1">
                                        <h6>Cargo</h6>
                                        <Form.Control
                                            type="text"
                                            placeholder="Cargo"
                                            value={cargo}
                                            onChange={(event) => setCargo(event.target.value)}
                                            isInvalid={errors.cargo}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.cargo}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>

                            </Row>

                            <Row id="multi">
                                <Col xs={6}>
                                    <div>
                                        <h6>Tipo de Negocio</h6>
                                        <MultiSelect id="multisele"
                                            options={options1}
                                            value={selected1}
                                            onChange={setSelected1}
                                            labelledBy="Select"
                                            hasSelectAll={false}
                                        />
                                    </div>
                                </Col>
                                <Col xs={6}>
                                    <div>
                                        <h6>¿Qué te interesa controlar?</h6>
                                        <MultiSelect id="multisele"
                                            options={options}
                                            value={selected}
                                            onChange={setSelected}
                                            labelledBy="Select"
                                            hasSelectAll={false}
                                        />
                                    </div>
                                </Col>

                            </Row>
                            <Row>
                            
                            <Col xs={6}>
                            <div>
                                <h6>¿Dónde nos conociste?</h6>
                                
                            <Select value={origen.find((option) => option.value === selectedOrigen)}
                            onChange={(selectedOption) => setSelectedOrigen(selectedOption.value)}
                             options={origen} styles={customStyles} isRequired/>  
                            {errors.origen && <div className="text-danger">{errors.origen}</div>}
                            </div>
                            </Col>

                            </Row>
                            <Row id='mess'>
                                <Form.Group controlId="formMessage" className="mb-3 py-1" >
                                    <h6>Mensaje</h6>
                                    <Form.Control
                                        as="textarea"
                                        rows={5}
                                        placeholder="Mensaje"
                                        value={message}
                                        onChange={(event) => setMessage(event.target.value)}
                                        isInvalid={errors.message}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.message}</Form.Control.Feedback>
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                    <Col xs={12}>
                                        <Form.Check 
                                            type="checkbox"
                                            id="privacyCheck"
                                            checked={privacyAccepted}
                                            onChange={(e) => setPrivacyAccepted(e.target.checked)}
                                            isInvalid={!!errors.privacy}
                                            label={
                                                <span>

He leído y acepto el <a href="https://www.tspoonlab.com/politica-de-privacidad/" target="_blank" rel="noopener noreferrer" className="text-ee3750">Aviso legal y la Política de privacidad.</a>*

                                                </span>
                                            }
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.privacy}</Form.Control.Feedback>
                                    </Col>
                                </Row>

                                <Row className="mb-4">
                                    <Col xs={12} className="d-flex justify-content-center recaptcha">
                                        <ReCAPTCHA
                                            sitekey='6LdtGdUlAAAAAIi0Np497UZOROW0sbDyhpaT562_'
                                            ref={captchaRef}
                                        />
                                    </Col>
                                </Row>

                                {errors.submit && (
                                    <Row className="mb-3">
                                        <Col xs={12}>
                                            <div className="alert alert-danger" role="alert">
                                                {errors.submit}
                                            </div>
                                        </Col>
                                    </Row>
                                )}

                                <Row>
                                    <Col xs={12} className="d-flex justify-content-center">
                                        <Button variant="primary" className="bg-ee3750" type="submit">
                                            Enviar
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </Card.Body>
                    </Card>

                   
                </Col>
            </Row>
                <Modal show={showModal} onHide={closeModal}>



                    <Modal.Body>



                        {!done && <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                height: '50vh', // Adjust the height as per your requirements
                            }}
                        >
                            <TailSpin
                                height="160"
                                width="160"
                                color="#ee3750"
                                ariaLabel="tail-spin-loading"
                                radius="1"
                                wrapperStyle={{}}
                                wrapperClass=""
                                visible={true}
                            />
                        </div>}

                        {done &&

                            <h1>"Gracias!
                                Hemos recibido tu formulario de contacto,
                                en breve nos pondremos en contacto contigo"</h1>
                        }

                    </Modal.Body>
                    <Modal.Footer>

                        {done && <Button variant="secondary" onClick={closeModal}>
                            Volver
                        </Button>}
                    </Modal.Footer>
                </Modal>
                </Container>
    );
}

export default Contacto;

